module.exports = "<div>\n  <h2>You have been signed out.</h2>\n  <p>\n    <button type=\"button\" xpo-btn=\"primary\" (click)=\"returnToApp()\">Return to Application</button>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/signedout/signedout.component.html
// module id = ../../../../../src/app/signedout/signedout.component.html
// module chunks = main